import React from "react";
import PropTypes from "prop-types";

import { DialogContent, Grid, Paper, Typography, Box } from "@mui/material";

import { getColor, getIcon, getBlockTypes } from "utils/pageElements/helpers";

const Content = ({ orgHasCalendar, onSelect }) => {

  const blockTypes = getBlockTypes(orgHasCalendar);

  return (
    <DialogContent>
      <Grid container spacing={2} sx={{ mt: 1 }}>
        {blockTypes.map((blockType) => (
          <Grid item xs={12} sm={6} key={blockType.type}>
            <Paper
              elevation={1}
              sx={{
                p: 2,
                cursor: "pointer",
                border: "1px solid rgba(0,0,0,0.1)",
                transition: "all 0.2s",
                "&:hover": {
                  boxShadow: 3,
                  borderColor: getColor(blockType.type),
                },
              }}
              onClick={() => onSelect(blockType.type)}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box
                  sx={{
                    minWidth: 46,
                    minHeight: 46,
                    borderRadius: 1.5,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mr: 2,
                    bgcolor: getColor(blockType.type),
                    color: "white",
                  }}
                >
                  {getIcon(blockType.type)}
                </Box>
                <Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                    {blockType.label}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {blockType.description}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </DialogContent>
  );
};

Content.propTypes = {
  orgHasCalendar: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default Content;
